import {useContext, useEffect, useState} from 'react';
import {Select, SelectContent, SelectGroup, SelectItem, SelectTrigger, SelectValue, useToast} from 'alm-react-components';
import {useTranslation} from 'react-i18next';
import {apis} from '../../services/alm';
import {AppContext} from '../../context/AppProvider';
import {ActionType, DUTCH_LANG_COUNTRIES} from '../../assets/constants/constants';
import useLanguage from '../../hooks/useLanguage';
import {fetchLanguages, updateLanguageSetting} from '../../services/user';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';

const SelectDropdown = () => {
  const {t, i18n} = useTranslation();
  const {state, dispatch} = useContext(AppContext);
  const navigate = useNavigate();
  const [ activeLanguages,setActiveLanguages] = useState<any>();
  const params = new URLSearchParams(window?.location?.search);
  const languageParam = params.get("language");
  const [contentLocale,setContentLocale]=useState<string>(languageParam || localStorage.getItem('locale') || '')
  const currentLanguage = useLanguage();
  const location = useLocation();
  const { toast } = useToast();

  // // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const getUserLocation = (languageCode: any, language: any) => {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;

          // Use reverse geocoding service to get the country from latitude and longitude
          try {
            dispatch({ type: ActionType.SET_LOADING, payload: true });
            const response = await axios.get(
              `https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`
            );

            const countryCode = response?.data?.address?.country_code;
            console.log('Address : ',response?.data?.address);

            if (countryCode && DUTCH_LANG_COUNTRIES.includes(countryCode?.toLowerCase())) {
              localStorage.setItem('i18nextLng', 'nl');
              localStorage.setItem('locale', 'nl-NL');
              i18n.changeLanguage('nl');
              setContentLocale('nl-NL');
            } else {
              localStorage.setItem('i18nextLng', 'en');
              localStorage.setItem('locale', 'en-US');
              i18n.changeLanguage('en');
              setContentLocale('en-US');
            }
            dispatch({ type: ActionType.SET_LOADING, payload: false });
          } catch (err) {
            toast({
              description: t("Common.locationLoadingError"),
              variant: "error",
            });
            dispatch({ type: ActionType.SET_LOADING, payload: false });
          }
        },
        (error) => {
          dispatch({ type: ActionType.SET_LOADING, payload: false });
          console.log('Location access denied : ',error);
          localStorage.setItem('i18nextLng', languageCode);
          localStorage.setItem('locale', language);
          i18n.changeLanguage(languageCode);
          setContentLocale(language);
        }
      );
    } else {
      console.log('Geolocation is not supported by your browser.');
    }
  }

  useEffect(() => {
    const fetchActiveLanguages = async () => {
      try {
        const response: any = await fetchLanguages();
        setActiveLanguages(response?.data);
        if((location?.pathname === '/' || location?.pathname?.includes('/sign-up')) && response?.data && !localStorage.getItem('locale')) {
          const defaultLang: any = response.data?.find((rs: any) => rs.isDefault === 1)
          const defaultLangCode: any = defaultLang?.code?.split('-')[0]
          getUserLocation(defaultLangCode, defaultLang?.code);
        }
      } catch (error) {
        toast({
          description: t("Common.languageLoadingError"),
          variant: "error",
        });
        console.error(error);
      }
    }
    fetchActiveLanguages();
  }, [ location?.pathname ]);

  const updateUserSettingsInALM = async (language: string) => {
    const userID = state.user?.userId;

    // Proceed with the API call only if the user is logged in
    const response = await apis.updateUserContent(userID, language);
    return response;
  };

  const handleChangeLanguage = async (language: string) => {

    localStorage.setItem('i18nextLng', language.split("-")[0]);
    localStorage.setItem('locale', language);

    dispatch({ type: ActionType.SET_LOADING, payload: true });
    setContentLocale(language);

    // Update user settings in ALM if the user is logged in
    // Conditionally update the language setting only if the user is logged in
    if (state.user?.userId) {
      await updateUserSettingsInALM(language);
      await updateLanguageSetting(language);
    }
    i18n.changeLanguage(language.split("-")[0]);
    navigate(0);
    window.scrollTo(0, 0);
  };

  return (
    <Select onValueChange={handleChangeLanguage} value={contentLocale}>
      <SelectTrigger className="w-[180px] justify-evenly select-languages-dr">
        <SelectValue placeholder={currentLanguage.label} className="text-lg" />
      </SelectTrigger>
      <SelectContent>
        {activeLanguages?.map((res: any) => (
          <SelectGroup key={res?.id}>
            <SelectItem key={res?.id} value={res.code}>{t(`Footer.${res.name}`)}</SelectItem>
          </SelectGroup>
        ))}
      </SelectContent>
    </Select>
  );
};

export default SelectDropdown;
